import axios from 'axios';
import { API_BASE_URL } from '../../utils/apiConfig';

const BACKEND_URL = API_BASE_URL;
const API = `${BACKEND_URL}/api/admin`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('adminToken');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export const getAllUsers = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.role) params.append('role', filters.role);
    if (filters.verification_status) params.append('verification_status', filters.verification_status);
    if (filters.is_suspended !== undefined) params.append('is_suspended', filters.is_suspended);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.skip) params.append('skip', filters.skip);
    
    const response = await axios.get(`${API}/users?${params.toString()}`, {
      headers: getAuthHeaders()
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to fetch users'
    };
  }
};

export const getUserDetails = async (userId) => {
  try {
    const response = await axios.get(`${API}/users/${userId}`, {
      headers: getAuthHeaders()
    });
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to fetch user details'
    };
  }
};

export const updateUserVerification = async (userId, status, rejectionReason = null) => {
  try {
    const response = await axios.patch(
      `${API}/users/${userId}/verification?verification_status=${status}${rejectionReason ? `&rejection_reason=${rejectionReason}` : ''}`,
      {},
      { headers: getAuthHeaders() }
    );
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to update verification'
    };
  }
};

export const suspendUser = async (userId, durationDays, reason) => {
  try {
    const response = await axios.post(
      `${API}/users/${userId}/suspend`,
      { duration_days: durationDays, reason },
      { headers: getAuthHeaders() }
    );
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to suspend user'
    };
  }
};

export const unsuspendUser = async (userId) => {
  try {
    const response = await axios.post(
      `${API}/users/${userId}/unsuspend`,
      {},
      { headers: getAuthHeaders() }
    );
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to unsuspend user'
    };
  }
};

export const resetUserPassword = async (userId, newPassword) => {
  try {
    const response = await axios.post(
      `${API}/users/${userId}/reset-password`,
      { new_password: newPassword },
      { headers: getAuthHeaders() }
    );
    return { success: true, data: response.data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || 'Failed to reset password'
    };
  }
};

